import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import { gr } from "../tokens";

// Checkbox with its label ("I understand…" in forms and dialogs). Brand when ticked, danger outline
// with `error`. The whole label is clickable; keep the text short and plain.
export default function GrCheckbox({ checked, onChange, label, error = false, disabled = false, id, sx }) {
  return (
    <Box
      component="label"
      htmlFor={id}
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: gr.space[2],
        cursor: disabled ? "default" : "pointer",
        fontFamily: gr.font.family,
        fontSize: gr.font.size.sm,
        lineHeight: gr.font.lineHeight.normal,
        color: disabled ? gr.color.muted : gr.color.ink2,
        ...sx,
      }}
    >
      <Checkbox
        id={id}
        checked={Boolean(checked)}
        onChange={(e) => onChange && onChange(e.target.checked)}
        disabled={disabled}
        disableRipple
        inputProps={{ "aria-invalid": error || undefined }}
        sx={{
          p: 0,
          mt: "2px",
          flex: "none",
          color: error ? gr.color.danger : gr.color.lineStrong,
          "&.Mui-checked": { color: gr.color.brand },
          "&.Mui-focusVisible": { boxShadow: gr.shadow.focus, borderRadius: gr.radius.chip },
          "& svg": { width: gr.icon.lg, height: gr.icon.lg },
        }}
      />
      <Box component="span" sx={{ minWidth: 0 }}>
        {label}
      </Box>
    </Box>
  );
}

GrCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.node.isRequired,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  sx: PropTypes.object,
};
